<template>
    <div>
        <div v-if="ready && eventInfo">
            <div class="row">
                <div class="col-md-8">
                    <div class="q-display-1">Event: {{ eventInfo.name }}</div>
                </div>
                <div class="col-md-4 text-right">
                    <q-btn color="secondary" label="Add Group/Team" icon="add" @click="addGroup" class="q-mr-lg"></q-btn>
                    <q-btn color="primary" label="Save" icon="save" @click="save"></q-btn>
                </div>
            </div>
            <!-- TODO: for each group - create a list - draggable to a different list.  The list must be in a data prop, not computed -->
            <div class="row">
                <!-- NO TEAM ATTENDEES -->
                <div class="col-3" v-if="attendeesWithoutGroup && attendeesWithoutGroup.length">
                    <q-card class="mdi-card q-mb-lg">
                        <q-card-main class="q-pa-none">
                            <q-list highlight separator>
                                <q-list-header>
                                    <div class="row">
                                        <div class="col-6 text-primary">No Team Assigned</div>
                                    </div>
                                </q-list-header>
                                <div
                                        v-for="(attendee, index) in attendeesWithoutGroup"
                                        class="items-center"
                                        :id="attendee.id"
                                        v-if="attendee"
                                        :key="attendee.id"
                                >
                                    <q-item separator>
                                        <q-item-side left>
                                            <q-item-tile color="black" v-if="attendee.purchaseId">
                                                {{ attendee.purchaseId }}
                                            </q-item-tile>
                                        </q-item-side>
                                        <q-item-main :class="[dragging ? 'moving' : '']">
                                            <span v-if="attendee.person && attendee.person.firstName && attendee.person.lastName">{{ attendee.person.firstName }} {{ attendee.person.lastName }}</span>
                                            <q-icon name="star" color="green" v-if="attendee.primaryRegistrant">
                                                <q-tooltip>Primary Registrant</q-tooltip>
                                            </q-icon>
                                            <br/>
                                            <small v-if="attendee.person && attendee.person.company && attendee.person.company.name">
                                                ({{ attendee.person.company.name }})
                                            </small>
                                        </q-item-main>
                                        <q-item-side right>
                                            <q-item-tile icon="swap_horiz" color="black"
                                                         v-if="attendeesWithoutGroup && attendeesWithoutGroup[index] && attendeesWithoutGroup[index].eventTeamId === null && teamOptions && teamOptions.length">
                                                <q-popover>
                                                    <q-list separator link>
                                                        <q-item v-close-overlay
                                                                @click.native="changeTeams(attendee, team.value)"
                                                                v-for="team in teamOptions" :key="team.value">
                                                            <q-tooltip>Move to:</q-tooltip>
                                                            {{ team.label }}
                                                        </q-item>
                                                    </q-list>
                                                </q-popover>
                                            </q-item-tile>
                                        </q-item-side>
                                    </q-item>
                                    <q-item-separator style="display:block;"/>
                                </div>
                            </q-list>
                        </q-card-main>
                    </q-card>
                </div>
                <!-- TEAMS -->
                <div class="col-3" v-for="(group, groupIndex) in attendeesByGroup" :key="groupIndex">
                    <q-card class="mdi-card q-mb-lg">
                        <q-card-main class="q-pa-none">
                            <q-list highlight separator>
                                <q-list-header>
                                    <div class="row">
<!--                                        <div class="col-6">Group {{ findEventTeamName(groupIndex) }} {{ findEventTeamIndex(groupIndex) }} {{ groupIndex }}</div>-->
                                        <div class="col-6">
                                            {{ findEventTeamName(groupIndex) }}
                                            <q-popup-edit v-model="eventInfo.eventTeam[findEventTeamIndex(groupIndex)].teamName" v-if="eventInfo.eventTeam[findEventTeamIndex(groupIndex)]" buttons :validate="nameValidate">
                                                <q-field count>
                                                    <q-input v-model="eventInfo.eventTeam[findEventTeamIndex(groupIndex)].teamName" min="1" placeholder="Group/Team Name" />
                                                </q-field>
                                            </q-popup-edit>
                                        </div>
                                        <div class="col-6 text-right">
                                            <span :class="[{ 'text-negative': group.length > eventInfo.teamLimit }]">{{ group.length }}/{{ eventInfo.teamLimit }}</span>
                                            <q-btn icon="delete" flat color="negative" size="sm"
                                                   @click="deleteGroup(groupIndex)"/>
                                        </div>
                                    </div>
                                </q-list-header>
                                <div
                                        v-for="(attendee) in group"
                                        multiline :class="[sortable ? 'sorting' : '']"
                                        class="items-center"
                                        :id="attendee.id"
                                        v-if="attendee"
                                        :key="attendee.id"
                                >
                                    <q-item separator>
                                        <q-item-side left>
                                            <q-item-tile color="black" v-if="attendee.purchaseId">
                                                <strong>{{ attendee.purchaseId }}</strong>
                                                <q-tooltip>Registration ID</q-tooltip>
                                            </q-item-tile>
                                        </q-item-side>
                                        <q-item-main :class="[dragging ? 'moving' : '']">
                                            <span v-if="attendee.person && attendee.person.firstName && attendee.person.lastName">{{ attendee.person.firstName }} {{ attendee.person.lastName }}</span>
                                            <q-icon name="star" color="green" v-if="attendee.primaryRegistrant">
                                                <q-tooltip>Primary Registrant</q-tooltip>
                                            </q-icon>
                                            <br/>
                                            <small v-if="attendee.person && attendee.person.company && attendee.person.company.name">
                                                ({{ attendee.person.company.name }})
                                            </small>
                                        </q-item-main>
                                        <q-item-side right>
                                            <q-item-tile icon="swap_horiz" color="black"
                                                         v-if="attendees && attendees[findAttendeeIndex(attendee.id)] && attendees[findAttendeeIndex(attendee.id)].eventTeamId">
                                                <q-popover>
                                                    <q-list separator link>
                                                        <q-item v-close-overlay
                                                                @click.native="changeTeams(attendee, team.value)"
                                                                v-for="team in teamOptions" :key="team.value">
                                                            <q-tooltip>Move to:</q-tooltip>
                                                            {{ team.label }}
                                                        </q-item>
                                                    </q-list>
                                                </q-popover>
                                            </q-item-tile>
                                        </q-item-side>
                                    </q-item>
                                    <q-item-separator style="display:block;"/>
                                </div>
                            </q-list>
                        </q-card-main>
                    </q-card>
                </div>
            </div>
            <!--v-if="attendees && attendees.length > 0 && dataColumns"-->
            <!--<q-alert type="negative" v-else>No attendees found for this event</q-alert>-->
            <!-- END TABLE OF ATTENDEES -->
            <q-inner-loading :visible="loading"></q-inner-loading>
        </div>
    </div>
</template>

<script>
import {dateFormat} from '../../plugins/filters'
// import draggable from 'vuedraggable'
// import { extend } from 'quasar'

export default {
  name: 'EventGroups',
  // components: {
  //   draggable
  // },
  props: {
    eventId: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      loading: true,
      ready: false,
      open: false,
      sortable: true,
      dragging: false,
      disableDrag: false,
      moving: false,
      dataChanged: false,
      attendees: [],
      // teamOptions: [],
      attendeesByGroup: [],
      attendeesWithoutGroup: [],
      eventInfo: {},
      additionalGroups: []
    }
  },
  async created () {
    await this.getEvent()
    await this.getAttendees()
    this.ready = true
    this.loading = false
  },
  computed: {
    dragOptions () {
      return {
        group: {
          // name: !this.sortable ? 'nestedGroup' : `nestedGroup__${this.parentId}`,
          name: 'eventTeam',
          pull: !this.sortable,
          put: !this.sortable
        },
        sort: this.sortable,
        handle: '.handle',
        ghostClass: 'sortable-ghost',
        dragClass: 'sortable-drag',
        moving: this.moving,
        disabled: this.disableDrag
      }
    },
    curratedAttendees () {
      if (this.attendees && this.attendees.length > 0) {
        let attendees = this.attendees.map(value => {
          let i = value
          if (value.person.id === value.purchase.personId) {
            i.primaryRegistrant = true
          } else {
            i.primaryRegistrant = false
          }
          return i
        })
        // Group registrations with the primary registrant on top
        return attendees.sort((attendees1, attendees2) => {
          if (attendees1.purchase.id < attendees2.purchase.id) return -1
          if (attendees1.purchase.id > attendees2.purchase.id) return 1
          if (attendees1.primaryRegistrant < attendees2.primaryRegistrant) return 1
          if (attendees1.primaryRegistrant > attendees2.primaryRegistrant) return -1
        })
      }
      return null
    },
    teamOptions () {
      let teamOptions = []
      // if (this.attendeesByGroup && this.attendeesByGroup.length) {
      teamOptions.push({label: 'No Team', value: null})
      for (const group in this.attendeesByGroup) {
        teamOptions.push({label: this.findEventTeamName(group), value: parseInt(group)})
      }
      // }
      return teamOptions
    },
    maxTeamNum () {
      if (this.eventInfo && this.eventInfo.eventTeam && this.eventInfo.eventTeam.length) {
        this.eventInfo.eventTeam.map(et => et)
        let eventTeamNameNumbers = this.eventInfo.eventTeam.map(et => {
          let i = et.teamName && et.teamName.replace(/^\D+/g, '') ? parseInt(et.teamName.replace(/^\D+/g, '')) : 0
          return i
        })
        return Math.max(...eventTeamNameNumbers)
        // return Math.max(...eventTeamNameNumbers.map(o => o), 0)
      }
      return 0
    }
  },
  filters: {
    formatDate (date) {
      return dateFormat(date)
    },
    convertBool (val) {
      if (val) {
        return 'Yes'
      } else {
        return 'No'
      }
    }
  },
  methods: {
    // addGroup () {
    //   const newIndex = this.maxTeamId + 1
    //   console.log('Add Group', newIndex)
    //   this.$set(this.attendeesByGroup, newIndex, [])
    //   this.additionalGroups.push(newIndex)
    //   // this.attendeesByGroup[this.maxTeamId + 1] = []
    //   // const maxValueOfY = Math.max(...this.getAttendees().map(o => o.eventTeamId), 0)
    // },
    nameValidate (val) {
      if (val) {
        return true
      }
      return false
    },
    changeTeams (attendee, team) {
      this.attendees[this.findAttendeeIndex(attendee.id)].eventTeamId = team
      this.dataChanged = true
      this.populateAttendeesByGroup()
    },
    handleDropped (index, evt) {
      console.log('handleDropped', index, evt)
    },
    handleSort () {
      console.log('handleSort')
    },
    findEventTeamName (id) {
      if (this.eventInfo && this.eventInfo.eventTeam && this.eventInfo.eventTeam.length) {
        let eventTeam = this.eventInfo.eventTeam.filter(et => et.id === parseInt(id))
        // console.log('eventTeam', eventTeam)
        if (eventTeam[0]) {
          return eventTeam[0].teamName
        }
      } else {
        return 'NA'
      }
    },
    findEventTeamIndex (id) {
      let index = null
      // console.log('this.eventInfo.eventTeam', this.eventInfo.eventTeam, parseInt(id))
      if (id && this.eventInfo && this.eventInfo.eventTeam && this.eventInfo.eventTeam.length) {
        index = this.eventInfo.eventTeam.findIndex(a => a.id === parseInt(id))
      }
      // console.log('this.eventInfo.eventTeam[index].teamName', this.eventInfo.eventTeam[index].teamName)
      // console.log('findEventTeamIndex', index)
      return index
    },
    findAttendeeIndex (id) {
      let index = null
      if (id) {
        index = this.attendees.findIndex(a => a.id === id)
      }
      // console.log('findAttendeeIndex index', index, id)
      return index
    },
    populateAttendeesByGroup () {
      if (this.attendees && this.attendees.length > 0) {
        let attendees = {}
        // let attendeesWithoutGroup = []
        let cleanEventsTeams = this.eventInfo.eventTeam.filter(et => et.removalDate === null)
        for (const group of cleanEventsTeams) {
          if (group.id >= 0) {
            attendees[group.id] = this.curratedAttendees.filter(ca => ca.eventTeamId === group.id)
          }
        }
        let attendeesWithoutGroup = this.curratedAttendees.filter(ca => ca.eventTeamId === null)
        this.$set(this, 'attendeesByGroup', attendees)
        this.$set(this, 'attendeesWithoutGroup', attendeesWithoutGroup)
      }
    },
    async save () {
      let attendeeError = false
      let teamError = false
      try {
        for (let attendee of this.attendees) {
          let attendeeModel = {}
          attendeeModel.eventTeamId = attendee.eventTeamId
          attendeeModel.isDirty = true
          // PUT
          try {
            // delete attendeeModel.id
            const {data} = await this.$axios.put(`/api/personevent/${attendee.id}`, attendeeModel)
            if (data) {
              console.log('PUT Event Team Attendees Saved: ', data)
              this.dataChanged = false
            } else {
              attendeeError = true
            }
          } catch (e) {
            attendeeError = true
          }
        }
      } catch (e) {
        attendeeError = true
      }
      try {
        for (let eventTeam of this.eventInfo.eventTeam) {
          let eventTeamModel = {}
          eventTeamModel.teamName = eventTeam.teamName
          eventTeamModel.isDirty = true
          // PUT
          try {
            const {data} = await this.$axios.put(`/api/eventTeam/${eventTeam.id}`, eventTeamModel)
            if (data) {
              console.log('PUT Event Team Saved: ', data)
              this.dataChanged = false
            } else {
              teamError = true
            }
          } catch (e) {
            teamError = true
          }
        }
      } catch (e) {
        teamError = true
      }
      if (attendeeError) {
        this.$q.notify({
          message: 'Error saving attendees'
        })
      } else if (teamError) {
        this.$q.notify({
          message: 'Error saving Team Names'
        })
      }
    },
    async deleteGroup (id) {
      let submit = true
      if (this.dataChanged) {
        submit = false
        this.$q.notify({
          message: 'Please save your changes before deleting a group, or reload the page and try again.'
        })
      }
      if ((this.attendeesByGroup[id] && this.attendeesByGroup[id].length)) {
        submit = false
        this.$q.notify({
          message: 'Please remove all attendees from this group before deleting.'
        })
      }
      if (submit) {
        await this.$q.dialog({
          title: 'Confirm Deletion of Group',
          message: 'Are you sure you want to remove this group?',
          ok: {
            label: 'Delete',
            color: 'negative'
          },
          cancel: true
        })
        try {
          const {data} = await this.$axios.delete(`/api/eventTeam/${id}`)
          if (data) {
            console.log('DELETE eventTeam: ', data)
            await this.getEvent()
            this.populateAttendeesByGroup()
            // answer = data
          } else {
            this.$q.notify({
              message: 'Error creating Event Group'
            })
          }
        } catch (e) {
          this.$q.notify({
            message: 'Error creating Event Group'
          })
        }
      }
    },
    async addGroup () {
      let eventTeamModel = {
        description: '',
        eventId: this.eventId,
        id: 0,
        isDirty: true,
        removalDate: null,
        teamName: this.maxTeamNum + 1
      }
      try {
        const {data} = await this.$axios.post(`/api/eventTeam/`, eventTeamModel)
        if (data) {
          console.log('POST eventTeam Created: ', data)
          await this.getEvent()
          this.populateAttendeesByGroup()
          // answer = data
        } else {
          this.$q.notify({
            message: 'Error creating Event Group'
          })
        }
      } catch (e) {
        this.$q.notify({
          message: 'Error creating Event Group'
        })
      }
    },
    async getEvent () {
      try {
        const {data} = await this.$axios.get('/api/odata/event/paginate', {
          params: {
            $expand: 'EventType,EventTeam,EventDiscount,EventDate,Address,Sponsorship,Question($expand=QuestionOption)',
            $filter: `id eq ${this.eventId}`
          }
        })
        if (data && data.data && data.data[0]) {
          this.eventInfo = data.data[0]
        } else {
          this.$q.notify({
            message: 'Error fetching event data'
          })
        }
      } catch (e) {
        this.$q.notify({
          message: 'Error fetching event data'
        })
      }
    },
    async getAttendees () {
      try {
        const {data} = await this.$axios.get('/api/odata/personevent/paginate', {
          params: {
            // $expand: 'Answer($expand=Address($expand=State)),Person($expand=Company($expand=Address($expand=State)),PersonDietOption($expand=DietOption)),Purchase($expand=PurchaseType,FundAccountType,Payment,SponsorshipPurchase($expand=Sponsorship),EventDiscountPurchase($expand=EventDiscount))',
            $expand: 'EventTeam,Person($expand=Company($expand=Address($expand=State))),Purchase($expand=PurchaseType,FundAccountType,Payment,SponsorshipPurchase($expand=Sponsorship))',
            $filter: `eventId eq ${this.eventId} and removalDate eq null`,
            limit: 500
          }
        })
        if (data && data.data) {
          this.attendees = data.data
          this.populateAttendeesByGroup()
        } else {
          this.$q.notify({
            message: 'Error fetching attendee data'
          })
        }
      } catch (e) {
        this.$q.notify({
          message: 'Error fetching attendee data'
        })
      }
    }
  }
}
</script>

<style scoped></style>
